import * as React from "react";
import CustomYouTubePlayer from "pages/common/CustomYoutubePlayer";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const videoList = [
  { id: "vqIktWh6kjk", title: "SNLC Poothotta" },
  // Add more videos if needed
];

function VideoGallery() {
  const count = videoList.length;

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="container" id="testimonial">
      <div className="heading-container1">
        <h1 className="heading">Video Gallery</h1>
        <div className="yellow-line"></div>
      </div>

      <div className="row content-section g-5">
        {count === 1 ? (
          <div className="video-layout center">
            <CustomYouTubePlayer videoId={videoList[0].id} />
          </div>
        ) : count <= 3 ? (
          <div className="video-layout grid">
            {videoList.map((video) => (
              <div key={video.id} className="video-item">
                <h3>{video.title}</h3>
                <CustomYouTubePlayer videoId={video.id} />
              </div>
            ))}
          </div>
        ) : (
          <Slider {...sliderSettings} className="video-slider">
            {videoList.map((video) => (
              <div key={video.id} className="video-slide">
                <h3>{video.title}</h3>
                <CustomYouTubePlayer videoId={video.id} />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
}

export default VideoGallery;
